export const hourglass = () => (
  <path
    d="M4 2h16M4 22h16M6 2v2.254a7 7 0 003.117 5.824L12 12m0 0l2.883 1.922A7 7 0 0118 19.746V22m-6-10l2.883-1.922A7 7 0 0018 4.254V2m-6 10l-2.883 1.922A7 7 0 006 19.746V22"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
